import { Col, Row } from 'antd';
import Header from 'components/Commons/Header';
import LoadingSpinner from 'components/Commons/LoadingSpinner';
import useUserDetail from 'hooks/useUserDetail';
import { useEffect, useState } from 'react';
import FooterMenu from 'components/Commons/FooterMenu';
import { useAppDispatch, useAppTranslation } from 'app/hooks';
import { onChangeAuthPage, setShowSubMenu } from '../homeSlice';
import { Streamer } from 'models';
import { useLocation, useNavigate } from 'react-router-dom';
import streamApi from 'api/streamApi';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import AuthPage from 'features/auth/pages/AuthPage';
import TransactionModal from '../components/Modals/TransactionModal';
import ChangePasswordPage from 'features/auth/pages/ChangePasswordPage';

interface AllStreamerProps {}

const AllStreamPage: React.FC<AllStreamerProps> = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { isUserLoggedIn } = useUserDetail();
  const [streamers, setStreamers] = useState<Streamer[]>();
  const handleResponseError = useHandleResponseError();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const platform = new URLSearchParams(location.search).get('platform') || '';
  const navigate = useNavigate();
  const t = useAppTranslation();

  const [isShowChangePasswordForm, setIsShowChangePasswordForm] = useState<boolean>(false);
  const closeForm = (): void => {
    dispatch(onChangeAuthPage(-1));
    dispatch(setShowSubMenu(false));
    setIsShowChangePasswordForm(false);
  };

  const onShowChangePasswordPage = () => {
    if (isUserLoggedIn) setIsShowChangePasswordForm(true);
  };

  const getAllStreamer = async () => {
    setIsLoading(true);
    const { ok, body, error } = await streamApi.getStreamers({
      size: 9999,
      'platformName.contains': platform,
    });
    if (ok && body) {
      setStreamers(body);
    }
    setIsLoading(false);
    handleResponseError(error);
  };

  const handleItemClick = (streamerId: number, channel: string) => {
    navigate(`/streaming/streamer?streamerId=${streamerId}&chanel=${channel}`);
  };

  useEffect(() => {
    getAllStreamer();
  }, [platform]);

  return (
    <div className="all-game-page relative">
      <i className="version">Version 1.0</i>
      {isLoading && (
        <div className="overlay">
          <LoadingSpinner />
        </div>
      )}
      <div className={`body-waraper`}>
        <Header
          isStreaming
          onShowChangePasswordPage={onShowChangePasswordPage}
          isShowAllStreaming
        />
        {!isLoading && (
          <div className="casino-game-list search-casino-game">
            {streamers && streamers.length > 0 ? (
              <Row className="relative" gutter={[16, 16]} wrap={true}>
                {streamers.map((streamer) => (
                  <Col
                    lg={{ span: 4 }}
                    md={{ span: 4 }}
                    sm={{ span: 6 }}
                    xs={{ span: 8 }}
                    className="streamer-platform-item"
                  >
                    <div
                      className="streamer-image"
                      onClick={() => handleItemClick(streamer.id, streamer.platform.socialName)}
                    >
                      <img
                        onError={(e) => {
                          e.currentTarget.src = '/no_image.png';
                        }}
                        src={streamer.logo}
                        alt="preview"
                      />
                    </div>
                    <span className="streamer-title">{streamer.name}</span>
                  </Col>
                ))}
              </Row>
            ) : (
              <div className="no-streamer-message">{t('stream.noStreamer')}</div>
            )}
            <FooterMenu isShowAllStreaming onShowChangePasswordPage={onShowChangePasswordPage} />
          </div>
        )}
      </div>
      <ChangePasswordPage isShow={isShowChangePasswordForm} closePage={closeForm} />
      <AuthPage />
      <TransactionModal />
    </div>
  );
};

export default AllStreamPage;
